// @file Surface LTI v1.0 deprecation banner store
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfaceAccountsStore } from '@@/pinia/surface_accounts_store'
import { useSurfaceFreezeStore } from '@@/pinia/surface_freeze'
import { defineStore } from 'pinia'
import { computed } from 'vue'

const LTI_V1P0_CUTOFF_DATE = new Date('2026-08-01T00:00:00Z')
const LTI_V1P0_BANNER_START_DATE = new Date('2026-05-01T00:00:00Z')

const LEARN_MORE_URL_TEACHER = 'https://padlet.help/article/dlvu521bky-re-embed-padlets-after-lti-13-upgrade'
const LEARN_MORE_URL_ADMIN = 'https://padlet.help/article/vpnnca8v4r-migrate-lti-10-to-lti-13-admins'

const useSurfaceLtiV1p0DeprecationStore = defineStore('surfaceLtiV1p0Deprecation', () => {
  const surfaceStore = useSurfaceStore()
  const surfaceAccountsStore = useSurfaceAccountsStore()
  const surfaceFreezeStore = useSurfaceFreezeStore()

  const daysUntilCutoff = computed((): number => {
    const now = new Date()
    const diffMs = LTI_V1P0_CUTOFF_DATE.getTime() - now.getTime()
    return Math.max(1, Math.ceil(diffMs / (1000 * 60 * 60 * 24)))
  })

  const isWithinDateRange = computed((): boolean => {
    const now = new Date()
    return now >= LTI_V1P0_BANNER_START_DATE && now < LTI_V1P0_CUTOFF_DATE
  })

  const learnMoreUrl = computed((): string => {
    return surfaceAccountsStore.isLibraryOwner || surfaceAccountsStore.isLibraryAdmin
      ? LEARN_MORE_URL_ADMIN
      : LEARN_MORE_URL_TEACHER
  })

  const xBanner = computed((): boolean => {
    return (
      surfaceStore.isLtiV1p0 &&
      !surfaceStore.isLtiV1p0BannerHidden &&
      surfaceStore.canUseLibraryAsTeacher &&
      isWithinDateRange.value &&
      !surfaceFreezeStore.isFrozenDueToFrozenTenantOrLibrary
    )
  })

  return {
    xBanner,
    daysUntilCutoff,
    learnMoreUrl,
  }
})

export { useSurfaceLtiV1p0DeprecationStore }
